import Icon from '@Components/generic/icon';
import getMetricIcon from '@Containers/app/stat-cards/tooltips/get-metric-icon';
import { AppContext } from '@Context/common/general/context';
import useI18n from "@i18n";

import { Stack, Typography, useTheme } from '@mui/material';
import { useContext } from 'react';

const ScanFrequencyTooltip = (props: any) => {
    const theme = useTheme();
    const { state } = useContext(AppContext);
    const { i18n } = useI18n();

    const isMobile = state.device.isMobile;
    return (
      <Stack
        spacing={2}
        sx={{
          paddingTop: theme.spacing(2),
          paddingLeft: theme.spacing(2.5),
          paddingRight: theme.spacing(2.5),
          paddingBottom: theme.spacing(2.5),
          backgroundColor: theme.palette.dsNeutral.v400,
          width: isMobile ? `${theme.spacing(25)}` : `${theme.spacing(40)}`,
          maxWidth: isMobile ? `${theme.spacing(25)}` : `${theme.spacing(50)}`,
          borderRadius: "4px",
        }}
      >
        <Stack
          direction="row"
          sx={{
            alignItems: "center",
            whiteSpace: "nowrap",
            color: "common.white",
          }}
          spacing={1}
        >
          <Icon
            icon={getMetricIcon("SCAN_FREQUENCY")}
            sx={{
              fontSize: theme.spacing(3),
              color: "inherit",
            }}
          />
          <Typography
            sx={{
              fontSize: theme.spacing(2.375),
              fontFamily: "Optician-Sans",
              color: "common.white",
            }}
          >
            {i18n("metric.scan_frequency.name")}
          </Typography>
        </Stack>

        <Typography variant="textBase500" sx={{ color: "common.white" }}>
          {i18n("tooltip.scan_frequency.description")}
        </Typography>

        <Stack spacing={0.1}>
          <Typography variant="textBase600" sx={{ color: "common.white" }}>
            {i18n("tooltip.scan_frequency.how_measured")}
          </Typography>
          <Typography variant="textBase500" sx={{ color: "common.white" }}>
            <span style={{ color: theme.palette.dsPrimary.v300 }}>
              {i18n("tooltip.scan_frequency.scans_per_second.unit")} -{" "}
            </span>
            {i18n("tooltip.scan_frequency.scans_per_second")}
          </Typography>
        </Stack>

        <Typography
          sx={{
            fontStyle: "italic",
            fontSize: theme.spacing(1.75),
            color: theme.palette.dsSecondaryYellow.v300,
            fontWeight: 400,
          }}
        >
          {i18n("tooltip.scan_frequency.tip")}
        </Typography>
      </Stack>
    );
}

export default ScanFrequencyTooltip;